/**
 * Various utilites porting some callback based JS native functions into
 * functions returning a promise, which can be "await"ed.
 */
export class Async
{
    public static timeout(timeoutMs: number): Promise<void>
    {
        return new Promise<void>((resolve) => {
            setTimeout(() => {
                resolve();
            }, timeoutMs);
        });
    }

    public static loadImage(resource: string): Promise<HTMLImageElement>
    {
        return new Promise<HTMLImageElement>((resolve) => {
            const image = new Image();

            image.addEventListener("load", () => {
                resolve(image);
            });

            image.src = resource;
        });
    }
}
